import React from "react";
import type { Meta, StoryObj } from "@storybook/react";
import { createStackNavigator } from "@react-navigation/stack";

import { MockedProvider } from "@apollo/client/testing";
import { GET_ASSET } from "../../graphql/asset";
import { buildAsset, buildInvoice } from "../factories";
import InvoiceDetailsScreen from "../../screens/client/InvoiceDetails";
import { GET_INVOICE } from "../../graphql/invoices";

const Stack = createStackNavigator<{
    InvoiceDetails: { invoiceId: string };
}>();

const StoryComponent = () => {
    const mocks = [
        {
            request: {
                query: GET_INVOICE,
                variables: {
                    invoiceId: "007",
                },
            },
            maxUsageCount: Number.POSITIVE_INFINITY,
            newData: () => ({
                data: {
                    getInvoice: buildInvoice({
                        id: "007",
                        invoiceAsset: buildAsset({
                            id: "asset-01",
                        }),
                    }),
                },
            }),
        },
        {
            request: {
                query: GET_ASSET,
                variables: {
                    assetId: "asset-01",
                },
            },
            maxUsageCount: Number.POSITIVE_INFINITY,
            newData: () => {
                return {
                    data: {
                        getAsset: buildAsset({ id: "asset-01" }),
                    },
                };
            },
        },
    ];
    return (
        <MockedProvider mocks={mocks}>
            <Stack.Navigator initialRouteName="InvoiceDetails">
                <Stack.Screen
                    name="InvoiceDetails"
                    component={InvoiceDetailsScreen}
                    options={{ headerShown: true, title: "Facture" }}
                    initialParams={{
                        invoiceId: "007",
                    }}
                />
            </Stack.Navigator>
        </MockedProvider>
    );
};

const meta = {
    title: "Screens/Invoice details",
    component: StoryComponent,
    argTypes: {},
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
